<div class="invoice-import-detail" *ngIf="imp">
  <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="back()">
      <nb-icon icon="arrow-back-outline"></nb-icon>
      {{ 'INVOICE_IMPORTS.DETAIL.BACK' | translate }}
    </button>
    <div class="d-flex flex-wrap gap-2">
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary"
        (click)="openPdf()"
        *ngIf="showPrimaryPdfOpen()"
        [disabled]="!imp.files?.length">
        {{ 'INVOICE_IMPORTS.DETAIL.OPEN_PDF' | translate }}
      </button>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="reparse()" *ngIf="!hasImportedLine()">
        {{ 'INVOICE_IMPORTS.DETAIL.REPARSE' | translate }}
      </button>
      <button type="button" class="btn btn-sm btn-outline-dark" (click)="archiveImport()">
        {{ 'INVOICE_IMPORTS.DETAIL.ARCHIVE' | translate }}
      </button>
    </div>
  </div>

  <div class="alert alert-danger" *ngIf="loadError">{{ loadError }}</div>

  <div class="alert alert-warning" *ngIf="hasReconciliationWarning">
    {{ 'INVOICE_IMPORTS.DETAIL.RECON_WARNING' | translate }}
  </div>

  <div class="alert alert-info" *ngIf="showPairedArchiveBanner">
    {{ 'INVOICE_IMPORTS.PHASE2.PAIRED_ARCHIVE_BANNER' | translate }}
    <button type="button" class="btn btn-link btn-sm p-0 align-baseline" (click)="openPrimaryPairedImport()">
      {{ 'INVOICE_IMPORTS.PHASE2.OPEN_PRIMARY' | translate }}
    </button>
  </div>

  <nb-card class="mb-3">
    <nb-card-body>
      <div class="row g-2">
        <div class="col-md-6">
          <div class="fw-semibold">{{ imp.supplierDisplayName || imp.supplierKey }}</div>
          <div class="small text-muted">{{ documentTypeLabel() }}</div>
          <span class="badge bg-secondary mt-1 me-1">{{ sourceFormatBadgeLabel() }}</span>
          <div *ngIf="imp.documentType === 'credit_note'" class="badge bg-info mt-1">
            {{ 'INVOICE_IMPORTS.DETAIL.CREDIT_NOTE_BADGE' | translate }}
          </div>
          <span class="badge ms-1 mt-1" [ngClass]="imp.goodsReceipt?.status === 'complete' ? 'bg-success' : imp.goodsReceipt?.status === 'partial' ? 'bg-warning text-dark' : 'bg-light text-dark'">
            {{ 'INVOICE_IMPORTS.PHASE2.GOODS_RECEIPT_LABEL' | translate }}: {{ goodsReceiptBadgeLabel() }}
          </span>
        </div>
        <div class="col-md-6 text-md-end">
          <div>{{ 'INVOICE_IMPORTS.DETAIL.INVOICE_NO' | translate }}: {{ imp.invoiceNumber }} ({{ imp.invoiceSite }})</div>
          <div class="small" *ngIf="imp.supplierInvoiceNumber">
            {{ 'INVOICE_IMPORTS.DETAIL.SUPPLIER_INV' | translate }}: {{ imp.supplierInvoiceNumber }}
          </div>
          <div class="small">
            {{ 'INVOICE_IMPORTS.DETAIL.DELIVERY' | translate }}: {{ imp.deliveryDate | date:'dd/MM/yyyy' }}
          </div>
          <div class="small mt-1" *ngIf="imp.duplicateOfImportId">
            <a href="javascript:void(0)" (click)="openImportById(imp.duplicateOfImportId!)">
              {{ 'INVOICE_IMPORTS.LIST.DUPLICATE_LINK' | translate }} →
            </a>
          </div>
        </div>
      </div>

      <div
        class="reconciliation-strip mt-3 p-2 rounded"
        [class.bg-warning-subtle]="imp.reconciliation?.status === 'mismatch'"
        [class.bg-light]="imp.reconciliation?.status !== 'mismatch'">
        <span class="small fw-semibold">{{ 'INVOICE_IMPORTS.DETAIL.RECON_TITLE' | translate }}</span>
        <span class="ms-2 small">
          PDF: {{ formatMoney(imp.reconciliation?.expected) }} · Parsed: {{ formatMoney(imp.reconciliation?.parsed) }}
          · Δ {{ formatMoney(imp.reconciliation?.diff) }}
        </span>
      </div>

      <ul class="list-unstyled small mt-2 mb-0" *ngIf="imp.charges?.length">
        <li *ngFor="let c of imp.charges">{{ c.label }}: {{ formatMoney(c.amountInclVat) }}</li>
      </ul>
      <div class="fw-semibold mt-2">{{ 'INVOICE_IMPORTS.DETAIL.TOTAL' | translate }}: {{ formatMoney(imp.totals?.totalInclVat) }}</div>

      <ul class="list-unstyled small mt-3 mb-0 import-files-list" *ngIf="imp.files?.length">
        <li class="d-flex flex-wrap align-items-center gap-2 mb-1" *ngFor="let file of imp.files">
          <span class="text-muted">{{ file.filename }}</span>
          <button type="button" class="btn btn-link btn-sm p-0" (click)="onImportFileAction(file)">
            {{ importFileActionLabel(file) }}
          </button>
        </li>
      </ul>

      <div class="pairing-panel mt-3 p-2 rounded bg-light small" *ngIf="imp.pairing?.status && imp.pairing?.status !== 'none'">
        <div class="fw-semibold">{{ 'INVOICE_IMPORTS.PHASE2.PAIRING_TITLE' | translate }}: {{ pairingStatusLabel() }}</div>
        <div *ngIf="imp.pairing?.pdfTotalInclVat != null || imp.pairing?.fakTotalInclVat != null">
          PDF {{ formatMoney(imp.pairing?.pdfTotalInclVat) }} · FAK {{ formatMoney(imp.pairing?.fakTotalInclVat) }}
          · Δ {{ formatMoney(imp.pairing?.diff) }}
        </div>
        <button type="button" class="btn btn-link btn-sm p-0" *ngIf="pairedImport || imp.pairing?.pairedImportId" (click)="openLinkedPairedImport()">
          {{ 'INVOICE_IMPORTS.PHASE2.OPEN_PAIRED' | translate:{ number: pairedImport?.invoiceNumber || '…' } }}
        </button>
        <div class="d-flex flex-wrap gap-2 mt-2" *ngIf="imp.status !== 'paired'">
          <button type="button" class="btn btn-sm btn-outline-primary" (click)="togglePairPicker()">
            {{ 'INVOICE_IMPORTS.PHASE2.PAIR_WITH' | translate }}
          </button>
          <button type="button" class="btn btn-sm btn-outline-secondary" *ngIf="imp.pairing?.pairedImportId" (click)="confirmUnpair()">
            {{ 'INVOICE_IMPORTS.PHASE2.UNPAIR' | translate }}
          </button>
        </div>
        <div class="mt-2" *ngIf="pairPickerOpen">
          <input class="form-control form-control-sm mb-1" [(ngModel)]="pairSearchQ" (keyup)="searchPairCandidates()" />
          <button type="button" class="btn btn-sm btn-light w-100 text-start mb-1" *ngFor="let cand of pairSearchResults" (click)="confirmPair(cand)">
            {{ cand.invoiceNumber }} · {{ cand.sourceFormat }} · {{ cand.status }}
          </button>
        </div>
      </div>
      <div class="mt-2" *ngIf="(!imp.pairing?.status || imp.pairing?.status === 'none') && imp.status !== 'paired'">
        <button type="button" class="btn btn-sm btn-outline-primary" (click)="togglePairPicker()">
          {{ 'INVOICE_IMPORTS.PHASE2.PAIR_WITH' | translate }}
        </button>
        <div class="mt-2" *ngIf="pairPickerOpen">
          <input class="form-control form-control-sm mb-1" [(ngModel)]="pairSearchQ" (keyup)="searchPairCandidates()" />
          <button type="button" class="btn btn-sm btn-light w-100 text-start mb-1" *ngFor="let cand of pairSearchResults" (click)="confirmPair(cand)">
            {{ cand.invoiceNumber }} · {{ cand.sourceFormat }} · {{ cand.status }}
          </button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <nb-card class="mb-3 sub-advice-card" *ngIf="subAdviceBlock as sub">
    <nb-card-header class="py-2">{{ 'INVOICE_IMPORTS.DETAIL.SUB_ADVICE_TITLE' | translate }}</nb-card-header>
    <nb-card-body class="py-2">
      <div class="small text-muted mb-2" *ngIf="sub.reference || sub.dueDate">
        <span *ngIf="sub.reference">{{ 'INVOICE_IMPORTS.DETAIL.SUB_REFERENCE' | translate }}: {{ sub.reference }}</span>
        <span *ngIf="sub.dueDate" class="ms-2">{{ 'INVOICE_IMPORTS.DETAIL.SUB_DUE' | translate }}: {{ sub.dueDate }}</span>
      </div>
      <p class="small text-muted mb-2" *ngIf="isLegacySubAdvice(sub)">{{ 'INVOICE_IMPORTS.SUB.LEGACY_NOTE' | translate }}</p>
      <ul class="list-unstyled small mb-0" *ngIf="isLegacySubAdvice(sub)">
        <li *ngFor="let entry of sub.advice" class="mb-1">{{ subAdviceEntryLabel(entry) }}</li>
      </ul>
      <div class="table-responsive" *ngIf="!isLegacySubAdvice(sub)">
        <table class="table table-sm align-middle sub-advice-table mb-0">
          <thead>
            <tr class="small">
              <th>{{ 'INVOICE_IMPORTS.SUB.COL_MARKER' | translate }}</th>
              <th>{{ 'INVOICE_IMPORTS.SUB.COL_STATUS' | translate }}</th>
              <th>{{ 'INVOICE_IMPORTS.SUB.COL_DURATION' | translate }}</th>
              <th>{{ 'INVOICE_IMPORTS.SUB.COL_QTY' | translate }}</th>
              <th>{{ 'INVOICE_IMPORTS.SUB.COL_FROM' | translate }}</th>
              <th>{{ 'INVOICE_IMPORTS.SUB.COL_TO' | translate }}</th>
              <th>{{ 'INVOICE_IMPORTS.SUB.COL_LINES' | translate }}</th>
              <th>{{ 'INVOICE_IMPORTS.SUB.COL_ACTION' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of sub.advice; let i = index" [id]="'sub-advice-row-' + (entry.index ?? i)">
              <td><code class="sub-marker">{{ entry.markerRaw || entry.marker || '—' }}</code></td>
              <td>
                <span class="sub-status-text">{{ subStatusTextDisplay(entry) }}</span>
                <span class="d-block small text-muted" *ngIf="subStatusIsEmptyShort(entry)">
                  {{ 'INVOICE_IMPORTS.SUB.NO_STATUS_SHORT' | translate }}
                </span>
              </td>
              <td>
                <span class="badge" [ngClass]="subDurationBadgeClass(entry.duration)" [title]="subNoticeKindLabel(entry.noticeKind)">
                  {{ subDurationLabel(entry.duration) }}
                </span>
                <span class="d-block small text-muted">{{ subNoticeKindLabel(entry.noticeKind) }}</span>
              </td>
              <td>{{ entry.quantity ?? '—' }}</td>
              <td class="small">{{ entry.code || '—' }} · {{ entry.name || '—' }}</td>
              <td class="small">
                <ng-container *ngIf="entry.replacementCode || entry.replacementName; else noReplacement">
                  {{ entry.replacementCode || '—' }} · {{ entry.replacementName || '—' }}
                </ng-container>
                <ng-template #noReplacement>—</ng-template>
              </td>
              <td class="small">
                <div>
                  {{ 'INVOICE_IMPORTS.SUB.FROM_LINE' | translate }}:
                  <button type="button" class="btn btn-link btn-sm p-0 align-baseline" *ngIf="entry.fromLineId" (click)="scrollToInvoiceLine(entry.fromLineId!)">
                    {{ 'INVOICE_IMPORTS.SUB.ON_INVOICE' | translate }}
                  </button>
                  <span *ngIf="!entry.fromLineId">{{ 'INVOICE_IMPORTS.SUB.NOT_ON_INVOICE' | translate }}</span>
                </div>
                <div>
                  {{ 'INVOICE_IMPORTS.SUB.TO_LINE' | translate }}:
                  <button type="button" class="btn btn-link btn-sm p-0 align-baseline" *ngIf="entry.toLineId" (click)="scrollToInvoiceLine(entry.toLineId!)">
                    {{ 'INVOICE_IMPORTS.SUB.ON_INVOICE' | translate }}
                  </button>
                  <span *ngIf="!entry.toLineId">{{ 'INVOICE_IMPORTS.SUB.NOT_ON_INVOICE' | translate }}</span>
                </div>
              </td>
              <td>
                <span class="badge bg-success d-block mb-1" *ngIf="entry.mapping as m">
                  {{ 'INVOICE_IMPORTS.SUB.MAPPED' | translate }}: {{ substitutionStrategyLabel(m.strategy) }}
                </span>
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="openSaveSubMapping(entry)">
                  {{
                    (entry.mapping ? 'INVOICE_IMPORTS.SUB.EDIT_MAPPING' : 'INVOICE_IMPORTS.SUB.SAVE_MAPPING') | translate
                  }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </nb-card-body>
  </nb-card>

  <div class="review-summary-bar mb-3" *ngIf="reviewSummary">
    <span class="small text-muted me-1">{{ 'INVOICE_IMPORTS.DETAIL.REVIEW_SUMMARY_PREFIX' | translate }}</span>
    <button
      type="button"
      class="btn btn-sm summary-chip"
      [class.active]="lineFilter === 'large'"
      (click)="setLineFilter('large')">
      {{ 'INVOICE_IMPORTS.DETAIL.REVIEW_SUMMARY_LARGE' | translate:{ count: reviewSummary.large } }}
    </button>
    <span class="mx-1">·</span>
    <button
      type="button"
      class="btn btn-sm summary-chip"
      [class.active]="lineFilter === 'toCheck'"
      (click)="setLineFilter('toCheck')">
      {{ 'INVOICE_IMPORTS.DETAIL.REVIEW_SUMMARY_TOCHECK' | translate:{ count: reviewSummary.toCheck } }}
    </button>
    <span class="mx-1">·</span>
    <button
      type="button"
      class="btn btn-sm summary-chip"
      [class.active]="lineFilter === 'unchanged'"
      (click)="setLineFilter('unchanged')">
      {{ 'INVOICE_IMPORTS.DETAIL.REVIEW_SUMMARY_UNCHANGED' | translate:{ count: reviewSummary.unchangedPending } }}
    </button>
    <button
      type="button"
      class="btn btn-sm btn-outline-primary ms-1"
      *ngIf="reviewSummary.unchangedPending > 0"
      (click)="bulkApproveUnchanged()">
      {{ 'INVOICE_IMPORTS.DETAIL.BULK_UNCHANGED' | translate }}
    </button>
    <span class="mx-1">·</span>
    <button
      type="button"
      class="btn btn-sm summary-chip"
      [class.active]="lineFilter === 'autoApproved' || autoApprovedPanelOpen"
      (click)="toggleAutoApprovedPanel()">
      {{ 'INVOICE_IMPORTS.DETAIL.REVIEW_SUMMARY_AUTO' | translate:{ count: reviewSummary.autoApproved } }}
    </button>
    <button
      type="button"
      class="btn btn-sm btn-link summary-all"
      [class.active]="lineFilter === 'all'"
      (click)="setLineFilter('all')">
      {{ 'INVOICE_IMPORTS.DETAIL.FILTER_ALL' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-sm btn-link summary-all"
      [class.active]="lineFilter === 'needs_review'"
      (click)="setLineFilter('needs_review')">
      {{ 'INVOICE_IMPORTS.DETAIL.FILTER_DEFAULT' | translate }}
    </button>
  </div>

  <p class="small text-muted mb-3 unchanged-hint" *ngIf="showUnchangedPendingHint">
    {{ 'INVOICE_IMPORTS.DETAIL.UNCHANGED_PENDING_HINT' | translate:{ count: unchangedPendingCount } }}
  </p>

  <nb-card class="mb-3 auto-approved-panel" *ngIf="autoApprovedPanelOpen && autoApprovedLines.length">
    <nb-card-header class="py-2">
      {{ 'INVOICE_IMPORTS.DETAIL.AUTO_APPROVED_TITLE' | translate:{ count: autoApprovedLines.length } }}
    </nb-card-header>
    <nb-card-body class="py-2">
      <div class="auto-line-row" *ngFor="let line of autoApprovedLines; trackBy: trackByLineId">
        <div class="flex-grow-1">
          <div class="fw-semibold">{{ lineProductName(line) }}</div>
          <div class="small text-muted" *ngIf="line.ean">EAN {{ line.ean }}</div>
          <div class="small">
            {{ formatKrPlain(line.autoApproval?.oldCost) }} → {{ formatKrPlain(line.autoApproval?.newCost) }} kr
            ({{ formatPercent(line.autoApproval?.costDeltaPercent) }})
          </div>
          <div class="info-chips mt-1" *ngIf="lineInfoReasons(line).length">
            <span class="badge info-reason-chip me-1" *ngFor="let ir of lineInfoReasons(line)">{{ infoReasonLabel(ir) }}</span>
          </div>
        </div>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          [title]="autoApprovalTooltip(line)"
          (click)="undoAutoApprove(line)">
          {{ 'INVOICE_IMPORTS.DETAIL.UNDO_AUTO_APPROVE' | translate }}
        </button>
      </div>
    </nb-card-body>
  </nb-card>

  <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
    <div class="fw-semibold">{{ 'INVOICE_IMPORTS.DETAIL.LINES_TITLE' | translate }}</div>
    <div class="d-flex flex-wrap gap-2">
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary"
        *ngIf="draftableUnmatchedCount > 0"
        (click)="bulkCreateDrafts()">
        {{ 'INVOICE_IMPORTS.PHASE2.BULK_DRAFT_CTA' | translate:{ count: draftableUnmatchedCount } }}
      </button>
      <button type="button" class="btn btn-sm btn-primary" (click)="confirmApply()" [disabled]="!canApply">
        {{ 'INVOICE_IMPORTS.DETAIL.APPLY_CTA_COUNT' | translate:{ count: applyLineCount } }}
      </button>
    </div>
  </div>

  <ul class="small text-muted mb-3" *ngIf="!canApply && applyBlockedReasons.length">
    <li *ngFor="let r of applyBlockedReasons">{{ blockedReasonLabel(r) }}</li>
  </ul>

  <nb-card class="mb-3 apply-result-card" *ngIf="applySummary">
    <nb-card-body>
      <div class="fw-semibold mb-2">{{ 'INVOICE_IMPORTS.DETAIL.APPLY_RESULT_TITLE' | translate }}</div>
      <p class="mb-2">
        {{ 'INVOICE_IMPORTS.DETAIL.APPLY_RESULT' | translate:{
          applied: applySummary.applied,
          stock: applySummary.stockUnitsAdded,
          cost: applySummary.costUpdated,
          price: applySummary.priceUpdated
        } }}
      </p>
      <ul class="small mb-0" *ngIf="applySummary.failed?.length">
        <li *ngFor="let f of applySummary.failed" class="text-danger">
          {{ failedLineLabel(f.lineId) }}: {{ f.error }}
        </li>
      </ul>
    </nb-card-body>
  </nb-card>

  <div class="text-center py-4 empty-lines-state" *ngIf="showNoLinesState">
    <p class="text-muted mb-2">{{ 'INVOICE_IMPORTS.DETAIL.NO_LINES' | translate }}</p>
    <div class="alert alert-warning small text-start d-inline-block" *ngIf="imp.parseError">{{ imp.parseError }}</div>
    <ul class="small text-muted text-start d-inline-block" *ngIf="imp.parseWarnings?.length">
      <li *ngFor="let w of imp.parseWarnings">{{ w }}</li>
    </ul>
  </div>

  <div class="text-center py-4 empty-lines-state" *ngIf="showEmptyFilterState && !showNoLinesState">
    <p class="text-muted mb-2">{{ 'INVOICE_IMPORTS.DETAIL.NO_LINES_IN_FILTER' | translate }}</p>
  </div>

  <ng-template #lineActions let-line="line" let-hideActions="hideActions">
    <ng-container *ngIf="!hideActions && isApprovableLine(line)">
      <div class="credit-kind mb-2" *ngIf="isCreditNote && line.lineType === 'product'">
        <label class="form-label small mb-1">{{ 'INVOICE_IMPORTS.PHASE2.CREDIT_KIND' | translate }}</label>
        <select
          class="form-select form-select-sm"
          [ngModel]="line.creditKind || 'return'"
          (ngModelChange)="setCreditKind(line, $event)">
          <option value="return">{{ 'INVOICE_IMPORTS.PHASE2.CREDIT_KIND_RETURN' | translate }}</option>
          <option value="price_correction">{{ 'INVOICE_IMPORTS.PHASE2.CREDIT_KIND_PRICE' | translate }}</option>
        </select>
        <button
          type="button"
          class="btn btn-sm btn-warning mt-1"
          *ngIf="hasQtyPriceSuspect(line)"
          (click)="swapQtyPrice(line)">
          {{ 'INVOICE_IMPORTS.PHASE2.SWAP_QTY_PRICE' | translate }}
        </button>
      </div>
      <div class="form-check small mb-1" *ngIf="!isCreditNote">
        <input
          class="form-check-input"
          type="checkbox"
          [(ngModel)]="lineDrafts[line._id].acceptCostPrice"
          (change)="onAcceptCostToggle(line)" />
        <label class="form-check-label">{{ 'INVOICE_IMPORTS.DETAIL.ACCEPT_COST' | translate }}</label>
      </div>
      <div class="cost-keep-reason mb-2" *ngIf="!lineDrafts[line._id].acceptCostPrice">
        <label class="form-label small mb-1">{{ 'INVOICE_IMPORTS.DETAIL.COST_KEEP_REASON_LABEL' | translate }}</label>
        <div class="d-flex flex-wrap gap-1 mb-1">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            *ngFor="let pickKey of costKeepQuickPickKeys"
            (click)="applyCostKeepQuickPick(line, pickKey)">
            {{ costKeepQuickPickLabel(pickKey) }}
          </button>
        </div>
        <input
          class="form-control form-control-sm"
          [(ngModel)]="lineDrafts[line._id].costKeepReason"
          [placeholder]="'INVOICE_IMPORTS.DETAIL.COST_KEEP_REASON_PLACEHOLDER' | translate" />
        <div class="text-danger small" *ngIf="lineApproveErrors[line._id]">{{ lineApproveErrors[line._id] }}</div>
      </div>
      <button
        type="button"
        class="btn btn-sm btn-outline-primary suggested-chip mb-1"
        *ngIf="line.suggestedSalePrice != null && line.suggestedSalePriceRule"
        (click)="useSuggestedPrice(line)">
        {{ suggestedPriceChipLabel(line) }}
      </button>
      <div class="input-group input-group-sm mb-1">
        <input
          type="number"
          class="form-control"
          [(ngModel)]="lineDrafts[line._id].newSalePrice"
          (change)="patchLineField(line)" />
        <button
          type="button"
          class="btn btn-outline-secondary"
          *ngIf="showUseRecommendedPrice(line)"
          (click)="useRecommendedPrice(line)">
          {{ 'INVOICE_IMPORTS.DETAIL.USE_RECOMMENDED_PLAIN' | translate }}
        </button>
      </div>
      <div class="btn-group btn-group-sm">
        <button type="button" class="btn btn-success" (click)="approveLine(line)">{{ 'INVOICE_IMPORTS.DETAIL.APPROVE' | translate }}</button>
        <button
          type="button"
          class="btn btn-outline-danger"
          [title]="'INVOICE_IMPORTS.DETAIL.REJECT_TOOLTIP' | translate"
          (click)="rejectLine(line)">
          {{ 'INVOICE_IMPORTS.DETAIL.REJECT' | translate }}
        </button>
      </div>
      <button
        type="button"
        class="btn btn-link btn-sm p-0 mt-1"
        *ngIf="canCreateDraft(line)"
        (click)="openCreateDraftDialog(line)">
        {{ 'INVOICE_IMPORTS.PHASE2.CREATE_DRAFT' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-link btn-sm p-0 mt-1"
        *ngIf="line.matchStatus === 'unmatched' || line.matchStatus === 'ambiguous'"
        (click)="startProductSearch(line)">
        {{ 'INVOICE_IMPORTS.DETAIL.LINK_PRODUCT' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-link btn-sm p-0 mt-1"
        *ngIf="line.matchStatus === 'matched' && line.productId && line.lineType === 'product'"
        (click)="openCostLayers(line)">
        {{ 'INVOICE_IMPORTS.PHASE2.COST_LAYERS_BTN' | translate }}
      </button>
      <div *ngIf="productSearchLineId === line._id" class="product-search mt-2">
        <input class="form-control form-control-sm" [(ngModel)]="productSearchQ" (keyup)="searchProducts()" />
        <button type="button" class="btn btn-sm btn-light w-100 text-start mt-1" *ngFor="let p of productSearchResults" (click)="linkProduct(line, p._id)">
          {{ p.name }} · {{ p.barcode }}
        </button>
      </div>
    </ng-container>
    <div class="small text-muted mt-1" *ngIf="line.costKeepReason && (line.reviewStatus === 'approved' || line.reviewStatus === 'imported')">
      {{ 'INVOICE_IMPORTS.DETAIL.COST_KEEP_REASON_STORED' | translate }}: {{ line.costKeepReason }}
    </div>
  </ng-template>

  <ng-template #lineMeta let-line="line" let-isDeposit="isDeposit">
    <div class="d-flex gap-2">
      <img *ngIf="lineImageUrl(line) && !isDeposit" [src]="lineImageUrl(line)" alt="" class="line-thumb" />
      <div class="flex-grow-1">
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <span class="severity-bar" *ngIf="!isDeposit" [ngClass]="line.changeSeverity | invoiceImportLineSeverityClass"></span>
          <span *ngIf="!isDeposit && severityLabel(line.changeSeverity)" [ngClass]="line.changeSeverity | invoiceImportLineSeverityBadgeClass">
            {{ severityLabel(line.changeSeverity) }}
          </span>
          <div class="fw-semibold">{{ isDeposit ? depositDisplayName(line) : lineProductName(line) }}</div>
          <span class="badge bg-info" *ngIf="isDraftLinkedLine(line)">{{ 'INVOICE_IMPORTS.PHASE2.DRAFT_CHIP' | translate }}</span>
          <span class="badge bg-secondary" *ngIf="line.transportStock">{{ 'INVOICE_IMPORTS.PHASE2.TRANSPORT_STOCK' | translate }}</span>
          <span class="badge bg-secondary" *ngIf="line.productSnapshot?.isActive === false">
            {{ 'INVOICE_IMPORTS.ATTENTION.PRODUCT_INACTIVE' | translate }}
          </span>
          <button
            type="button"
            class="badge border-0 sub-notice-badge"
            *ngIf="line.subNotice as sn"
            [ngClass]="subDurationBadgeClass(sn.duration)"
            [title]="subNoticeTooltip(line)"
            (click)="scrollToSubAdviceRow(sn.adviceIndex)">
            SUB: {{ sn.statusText || '—' }}
          </button>
        </div>
        <div class="small text-muted" *ngIf="line.ean">EAN {{ line.ean }}</div>
        <div class="small text-muted" *ngIf="lineOrderNo(line) as orderNo">
          {{ 'INVOICE_IMPORTS.DETAIL.ORDER_NO' | translate }}: {{ orderNo }}
        </div>
        <div class="info-chips" *ngIf="lineInfoReasons(line).length">
          <span class="badge info-reason-chip me-1" *ngFor="let ir of lineInfoReasons(line)">{{ infoReasonLabel(ir) }}</span>
        </div>
        <div class="attention-chips">
          <span class="badge bg-light text-dark me-1" *ngFor="let ar of visibleReasons(line.attentionReasons)">
            {{ attentionLabel(line, ar) }}
          </span>
        </div>
        <span class="badge me-1" [ngClass]="line.reviewStatus | invoiceImportLineReviewClass">{{ reviewStatusLabel(line.reviewStatus) }}</span>
        <span class="badge bg-light text-dark" *ngIf="line.lineType !== 'product'">{{ lineTypeLabel(line.lineType) }}</span>
        <span class="badge bg-light text-dark ms-1" *ngIf="line.matchStatus">{{ matchStatusLabel(line.matchStatus) }}</span>
        <div class="small text-muted mt-1" *ngIf="line.reviewStatus === 'imported' && line.applyResult">
          {{ 'INVOICE_IMPORTS.DETAIL.APPLIED_STOCK' | translate:{ n: line.applyResult.stockDelta } }}
          · cost {{ line.applyResult.costPriceBefore }}→{{ line.applyResult.costPriceAfter }}
          · price {{ line.applyResult.priceBefore }}→{{ line.applyResult.priceAfter }}
          <span *ngIf="line.applyResult.stockSkippedReason"> · {{ stockSkippedLabel(line.applyResult.stockSkippedReason) }}</span>
          <span *ngIf="line.applyResult.costSkippedReason"> · {{ costSkippedLabel(line.applyResult.costSkippedReason) }}</span>
          <span *ngIf="line.applyResult.stockClampedFrom != null">
            · {{ 'INVOICE_IMPORTS.PHASE2.STOCK_CLAMPED' | translate:{ from: line.applyResult.stockClampedFrom } }}
          </span>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #qtyCell let-line="line">
    <div>{{ quantityBreakdownLabel(line) }}</div>
    <div class="small text-muted" *ngIf="line.totalUnits != null">
      {{ 'INVOICE_IMPORTS.PHASE2.EXPECTED_UNITS' | translate }}: {{ line.totalUnits }}
    </div>
    <div class="small" *ngIf="line.countedUnits != null" [title]="countTooltip(line)">
      {{ 'INVOICE_IMPORTS.PHASE2.COUNTED_UNITS' | translate }}: {{ line.countedUnits }}
      <span class="badge bg-warning text-dark ms-1" *ngIf="countDeviationLabel(line)">{{ countDeviationLabel(line) }}</span>
    </div>
    <div class="small text-muted qty-hint">{{ 'INVOICE_IMPORTS.DETAIL.QTY_PDA_HINT' | translate }}</div>
  </ng-template>

  <div class="table-responsive d-none d-lg-block" *ngIf="!showNoLinesState && displayRows.length">
    <table class="table table-sm align-middle line-review-table">
      <thead>
        <tr>
          <th>{{ 'INVOICE_IMPORTS.DETAIL.COL_PRODUCT' | translate }}</th>
          <th>{{ 'INVOICE_IMPORTS.DETAIL.COL_QTY' | translate }}</th>
          <th>{{ 'INVOICE_IMPORTS.DETAIL.COL_COST' | translate }}</th>
          <th>{{ 'INVOICE_IMPORTS.DETAIL.COL_PRICE' | translate }}</th>
          <th>{{ 'INVOICE_IMPORTS.DETAIL.COL_ACTIONS' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of displayRows; trackBy: trackByDisplayRow"
          [id]="'invoice-line-' + row.line._id"
          [ngClass]="row.line.changeSeverity | invoiceImportLineSeverityClass"
          [class.line-indent-deposit]="row.indentLevel > 0"
          [class.line-highlight]="highlightLineId === row.line._id">
          <td>
            <ng-container *ngTemplateOutlet="lineMeta; context: { line: row.line, isDeposit: row.isDepositChild }"></ng-container>
          </td>
          <td>
            <ng-container *ngTemplateOutlet="qtyCell; context: { line: row.line }"></ng-container>
          </td>
          <td>
            <ng-container *ngIf="row.line.lineType === 'product'">
              <div class="small fw-semibold" *ngIf="costChangeLabel(row.line)">{{ costChangeLabel(row.line) }}</div>
              <div class="small fw-semibold" *ngIf="!costChangeLabel(row.line) && newCostOnlyLabel(row.line)">{{ newCostOnlyLabel(row.line) }}</div>
              <div class="small text-muted">{{ 'INVOICE_IMPORTS.DETAIL.MARGIN_BASIS_HINT' | translate }}</div>
              <div class="small">{{ marginTransitionLabel(row.line) }}</div>
            </ng-container>
          </td>
          <td>
            <ng-container *ngIf="row.line.lineType === 'product'">
              <div class="small" *ngIf="showRecommendedOnly(row.line)">{{ recommendedOnlyLabel(row.line) }}</div>
              <div class="small" *ngIf="!showRecommendedOnly(row.line) && retailGapLabel(row.line)">{{ retailGapLabel(row.line) }}</div>
              <div class="small" *ngIf="row.line.productSnapshot">
                {{ 'INVOICE_IMPORTS.DETAIL.CURRENT' | translate }}: {{ formatMoney(row.line.productSnapshot?.price) }}
              </div>
              <div class="small" *ngIf="row.line.marginPercentAtRecommendedPrice != null">{{ marginAtRecommendedLabel(row.line) }}</div>
              <div class="small" *ngIf="row.line.productSnapshot" [class.text-danger]="isMarginBelowMinimum(row.line)">
                {{ marginAtCurrentLabel(row.line) }}
              </div>
            </ng-container>
          </td>
          <td>
            <ng-container *ngTemplateOutlet="lineActions; context: { line: row.line, hideActions: row.hideApproveReject }"></ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="d-lg-none line-cards" *ngIf="!showNoLinesState && displayRows.length">
    <nb-card
      class="mb-2 line-card"
      *ngFor="let row of displayRows; trackBy: trackByDisplayRow"
      [id]="'invoice-line-' + row.line._id"
      [ngClass]="row.line.changeSeverity | invoiceImportLineSeverityClass"
      [class.line-indent-deposit]="row.indentLevel > 0"
      [class.line-highlight]="highlightLineId === row.line._id">
      <nb-card-body class="py-2">
        <ng-container *ngTemplateOutlet="lineMeta; context: { line: row.line, isDeposit: row.isDepositChild }"></ng-container>
        <ng-container *ngTemplateOutlet="qtyCell; context: { line: row.line }"></ng-container>
        <ng-container *ngIf="row.line.lineType === 'product'">
          <div class="small mb-1" *ngIf="costChangeLabel(row.line)">{{ costChangeLabel(row.line) }}</div>
          <div class="small mb-1" *ngIf="!costChangeLabel(row.line) && newCostOnlyLabel(row.line)">{{ newCostOnlyLabel(row.line) }}</div>
          <div class="small mb-1" *ngIf="showRecommendedOnly(row.line)">{{ recommendedOnlyLabel(row.line) }}</div>
          <div class="small mb-1" *ngIf="!showRecommendedOnly(row.line) && retailGapLabel(row.line)">{{ retailGapLabel(row.line) }}</div>
          <div class="small mb-1" *ngIf="row.line.marginPercentAtRecommendedPrice != null">{{ marginAtRecommendedLabel(row.line) }}</div>
          <div class="small mb-2">{{ marginTransitionLabel(row.line) }}</div>
        </ng-container>
        <ng-container *ngTemplateOutlet="lineActions; context: { line: row.line, hideActions: row.hideApproveReject }"></ng-container>
      </nb-card-body>
    </nb-card>
  </div>
</div>
